module.exports = __webpack_public_path__ + "assets/img/bg.c06d227b.svg";